import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

import InitialDataFormLayout from "../components/InitialDataFormLayout";
import {
    labelStyle,
    inputStyle,
    sectionHeaderStyle,
    sectionIconStyle,
    sectionTitleStyle,
} from "../components/formStyles";
import api from "../../../../utils/axios";
import { getAlert } from "../../../../utils/SamuiUtils";

const CoverForm = ({ callRefresh }) => {
    const [coverData, setCoverData] = useState(null);
    const [backData, setBackData] = useState(null);
    const [coverFile, setCoverFile] = useState(null);
    const [backFile, setBackFile] = useState(null);
    const [isLoadingCover, setIsLoadingCover] = useState(false);
    const [isLoadingBack, setIsLoadingBack] = useState(false);

    const handleBack = () => {
        window.location.href = "/initial-data";
    };

    useEffect(() => {
        fetchCoverData();
    }, []);

    const fetchCoverData = async () => {
        try {
            const response = await api.get("/cover-list");
            const payload = response.data && response.data.data ? response.data.data : [];
            if (Array.isArray(payload)) {
                const cover = payload.find((item) => item.Img_Type === "COVER");
                const back = payload.find((item) => item.Img_Type === "BACK");

                if (cover) setCoverData(cover);
                if (back) setBackData(back);
            }
        } catch (error) {
            console.error("Error fetching cover data:", error);
        }
    };

    const handleFileSelect = (event, type) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.type !== "application/pdf") {
            getAlert("WARNING", "กรุณาเลือกไฟล์ PDF เท่านั้น");
            event.target.value = "";
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const base64String = e.target.result.split(",")[1]; // ลบ data:application/pdf;base64,
            const fileData = {
                name: file.name,
                data: `data:${file.type};base64,${base64String}`,
                type: file.type,
            };

            if (type === "COVER") {
                setCoverFile(fileData);
            } else if (type === "BACK") {
                setBackFile(fileData);
            }
        };
        reader.readAsDataURL(file);
    };

    const handleUpload = async (type) => {
        try {
            const fileToUpload = type === "COVER" ? coverFile : backFile;

            if (!fileToUpload) {
                getAlert("WARNING", "กรุณาเลือกไฟล์ก่อน");
                return;
            }

            if (type === "COVER") {
                setIsLoadingCover(true);
            } else {
                setIsLoadingBack(true);
            }

            const payload = {
                Img_Name: fileToUpload.name,
                Img_Data: fileToUpload.data,
                Img_Type: type,
            };

            const response = await api.post("/cover-upload", payload);
            const resultData = response.data && response.data.data ? response.data.data : null;
            if (response.data && response.data.status === "OK") {
                getAlert("SUCCESS", `อัพโหลดข้อมูล${type === "COVER" ? "ปก" : "ท้าย"}สำเร็จ`);

                if (type === "COVER") {
                    setCoverData(resultData);
                    setCoverFile(null);
                } else {
                    setBackData(resultData);
                    setBackFile(null);
                }

                const fileInput = document.getElementById(
                    type === "COVER" ? "coverFileInput" : "backFileInput"
                );
                if (fileInput) {
                    fileInput.value = "";
                }
            } else {
                getAlert("FAILED", "เกิดข้อผิดพลาดในการอัพโหลด");
            }
        } catch (error) {
            console.error("Upload error:", error);
            getAlert("FAILED", error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพโหลด");
        } finally {
            setIsLoadingCover(false);
            setIsLoadingBack(false);
        }
    };

    const handleDelete = async (type) => {
        getAlert("C_DIALOG", `ต้องการลบข้อมูล${type === "COVER" ? "ปก" : "ท้าย"}หรือไม่?`, async (isConfirm) => {
            if (!isConfirm) return;

            try {
                const dataToDelete = type === "COVER" ? coverData : backData;

                const response = await api.post("/cover-delete", { Cover_Id: dataToDelete.Cover_Id });

                if (response.data && response.data.status === "OK") {
                    getAlert("SUCCESS", `ลบข้อมูล${type === "COVER" ? "ปก" : "ท้าย"}สำเร็จ`);

                    if (type === "COVER") {
                        setCoverData(null);
                        setCoverFile(null);
                    } else {
                        setBackData(null);
                        setBackFile(null);
                    }
                } else {
                    getAlert("FAILED", "เกิดข้อผิดพลาดในการลบ");
                }
            } catch (error) {
                console.error("Delete error:", error);
                getAlert("FAILED", error.response?.data?.message || "เกิดข้อผิดพลาดในการลบ");
            }
        });
    };

    const PDFPreview = ({ data, type }) => {
        if (!data) return null;

        return (
            <div className="row g-3 align-items-start" style={{ marginTop: 8 }}>
                <div className="col-12">
                    <div className="small text-muted">📄 {data.Img_Name}</div>
                </div>
                <div className="col-12">
                    <div className="card" style={{ borderRadius: 8, overflow: "hidden" }}>
                        <div style={{ height: 420 }}>
                            <embed
                                src={data.Img_Data}
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                style={{ display: "block" }}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="d-flex gap-2">
                        <button
                            onClick={() => handleDelete(type)}
                            className="btn btn-sm btn-danger"
                        >
                            <i className="fas fa-trash-alt me-2" /> ลบไฟล์
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <InitialDataFormLayout name={"ข้อมูลปกและท้าย"} onBack={handleBack} onReset={() => { setCoverFile(null); setBackFile(null); fetchCoverData(); }}>
            <div className="row g-4">
                <div className="col-12">
                    <div className="d-flex align-items-center gap-3">
                        <i className="fas fa-file-pdf fa-2x text-danger" />
                        <div>
                            <h5 className="mb-1">อัพโหลดรูปปก (Cover)</h5>
                            <div className="small text-muted">เลือกไฟล์ PDF สำหรับรูปปก</div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-8">
                    <div className="d-flex gap-2 align-items-center">
                        <input
                            id="coverFileInput"
                            type="file"
                            accept="application/pdf"
                            onChange={(e) => handleFileSelect(e, "COVER")}
                            className="form-control form-control-sm"
                        />
                        <button
                            onClick={() => handleUpload("COVER")}
                            disabled={!coverFile || isLoadingCover}
                            className="btn btn-sm btn-primary"
                        >
                            {isLoadingCover ? "กำลังอัพโหลด..." : "อัพโหลด"}
                        </button>
                    </div>
                    {coverFile && (
                        <div className="text-success small mt-2">✓ เลือกไฟล์: {coverFile.name}</div>
                    )}
                </div>

                <div className="col-12">
                    {coverData && <PDFPreview data={coverData} type="COVER" />}
                </div>

                <div className="col-12"><hr /></div>

                <div className="col-12">
                    <div className="d-flex align-items-center gap-3">
                        <i className="fas fa-file-pdf fa-2x text-danger" />
                        <div>
                            <h5 className="mb-1">อัพโหลดรูปท้าย (Back)</h5>
                            <div className="small text-muted">เลือกไฟล์ PDF สำหรับรูปท้าย</div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-8">
                    <div className="d-flex gap-2 align-items-center">
                        <input
                            id="backFileInput"
                            type="file"
                            accept="application/pdf"
                            onChange={(e) => handleFileSelect(e, "BACK")}
                            className="form-control form-control-sm"
                        />
                        <button
                            onClick={() => handleUpload("BACK")}
                            disabled={!backFile || isLoadingBack}
                            className="btn btn-sm btn-primary"
                        >
                            {isLoadingBack ? "กำลังอัพโหลด..." : "อัพโหลด"}
                        </button>
                    </div>
                    {backFile && (
                        <div className="text-success small mt-2">✓ เลือกไฟล์: {backFile.name}</div>
                    )}
                </div>

                <div className="col-12">
                    {backData && <PDFPreview data={backData} type="BACK" />}
                </div>
            </div>
        </InitialDataFormLayout>
    );
};

export default CoverForm;
